import React from 'react';
import '@topcon/te-web/dist/te-text';
import { TeEventListeners, useWebComponentWrapper } from './utils/utils';

interface Props extends TeEventListeners {
  size?: 10 | 12 | 14 | 16 | 24 | 32;
  weight?: 400 | 500 | 700;
  color?: string;
  align?: 'initial' | 'left' | 'right' | 'center';
  display?: 'flex' | 'block';
  truncate?: boolean;
  lineClamp?: number;
  italic?: boolean;

  children?: React.ReactChild | React.ReactChild[];
}

export default function TeText(props: Props): JSX.Element {
  const ref = React.useRef<HTMLElement>(null);
  useWebComponentWrapper(props, ref);
  return <te-text ref={ref}>{props.children}</te-text>;
}

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      'te-text': any;
    }
  }
}
